
import * as types from "./types";
import { JSON_STRING, HttpClient, MHTTPCL } from "../../../../services/http/http-client";
import { getNavTabModule } from "../../../../dt-plugins/sidewindow/nav-tab";
import { CostsService } from "../../services/costs.service";
import { EOL_REACHED } from "../../../../dt-plugins/advanced-search/load.model";
import { setMainNavInactive } from "../../../../store/app/mutations";
import router from '../../../../router';
import { MODIFICATION_URL } from '../../../booking/services/booking-service';
import { sum } from 'ramda';

const NavTabModule = getNavTabModule(types.CostsDetails, 'costsDetails');
export const costsActions = {
  async [types.CostData.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const costData = await CostsService.findCostData();
    commit(types.CostData.SET.ALL, costData.data);
  },
  // async [types.CostsList.SET.ALL]({ commit, getters }, payload) {
  //   commit(types.CostsList.SET.ALL, {
  //     ...getters.costsList,
  //     cost: payload
  //   });
  // },
  async [types.CostsList.FETCH.ALL]({ commit, getters, state }, payload) {
    const { start, row_count, searchMode, basicFilter, searchFilter } = payload;

    let res;

    if (searchMode === 'none') {
      if (start === 0) {
        res = await CostsService.findAllCosts({ start });
        // console.log('res', res.data.costs)
        commit(types.CostsList.SET.ALL, res.data.costs);
      } else {
        res = await CostsService.findAllCosts({ start });
        commit(types.CostsList.SET.ALL, [
          ...getters.costsList,
          ...res.data.costs
        ]);

        // Setting EOL
        if (!(res?.data?.costs?.length > 0)) {
          return EOL_REACHED;
        }
      }
    } else if (searchMode === 'basic') {
      const { searchString, cost_group_id, status_colors, invoice_project_id } = basicFilter;
      res = await CostsService.searchCosts({ search: searchString, cost_group_id, status_colors, invoice_project_id }, start);
      if (start === 0) {
        commit(types.CostsList.SET.ALL, res.data.costs);
      } else {
        commit(types.CostsList.SET.ALL, [
          ...getters.costsList,
          ...res.data.costs
        ]);
      }
      // Setting EOL
      if (!(res?.data?.costs?.length > 0)) {
        return EOL_REACHED;
      }
    } else if (searchMode === 'advanced') {
      res = await CostsService.advance_search({
        ...searchFilter,
        row_start: start
      });
      // console.log({'actions.js:62 res' : res});

      if (start === 0) {
        commit(types.CostsList.SET.ALL, res.data.costs);
      } else {
        commit(types.CostsList.SET.ALL, [
          ...getters.costsList,
          ...res.data.costs
        ]);
      }
      // Setting EOL
      if (!(res?.data?.costs?.length > 0)) {
        return EOL_REACHED;
      }
    }
  },


  async [types.CostsDetails.FETCH.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, invoice, reload } = payload;

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "invoice_id";
    const itemName = "invoice";
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "costsDetails";
    const DetailsAction = types.CostsDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true
      };
    });

    // HTTP Req
    const detailsData = await HttpClient.mergeRequests([
      CostsService.findCostOverViewTabData(invoice.invoice_id),
      CostsService.findCostAssignProjects(invoice.invoice_id),
      CostsService.invoiceTotalCostSplit(invoice.invoice_id),
      CostsService.findCostRoyaltyAccounts(invoice.invoice_id),
      CostsService.findCostContacts()
    ]);


    console.log("detailsData", detailsData);

    // DBox
    NavTabHelper.setSingleNavTabDetails(
      primaryKeyValue,
      (detailsDict, invoice) => {
        return {
          ...invoice,
          ...detailsData,
          loading: false,

        };
      }
    );
  },


  ...NavTabModule.implementActions(
    "invoice_id",
    "costs/invoice_id/tab",
    "costs",
    () => router,
    "accounting",
    (value, key) => {
      const { invoice } = value;
      console.log('invoice', invoice);
      return {
        title:
          value && value.full_name
            ? value.full_name
            : key,
        full_title:
          value && value.full_name
            ? value.full_name
            : key
      };
    }
  ),

  // async [types.AccountsDetails.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
  //   const NavTabHelper = NavTabModule.Helper(dispatch, getters);

  // },
  async [types.CHANGE_COST_TAX_DEDUC]({ commit, getters, dispatch }, payload) {
    // console.log(payload);
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    const {
      tax_type_id_deduction,
      item
    } = payload;
    const { invoice_id } = item;
    NavTabHelper.updateSingleNavTabDetails(invoice_id, (CostsDetails) => {
      return {
        invoice: {
          ...CostsDetails.invoice,
          tax_type_id_deduction,
        },
      }
    })

    const updateVatHandle = await CostsService.changeTaxDeduction({
      invoice_id,
      tax_group_id: tax_type_id_deduction
    });

    dispatch(types.FETCH_ONLY_COST_INVOICE, { invoice: item });
  },
  async [types.CostsList.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    commit(types.CostsList.DELETE.SINGLE, payload);

    const invoice_id = payload.invoice_id;

    // If SideWindow is Open, Delete the Tab
    if (getters?.costsDetails?.[invoice_id]) {
      dispatch(types.CostsDetails.DELETE.SINGLE, { invoice_id });
    }

    const nextAccountsList = await CostsService.deleteCost(invoice_id);
  },

  async [types.FETCH_ONLY_COST_INVOICE]({ getters, dispatch }, payload = {}) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    let { invoice } = payload;

    if (!invoice) {
      throw Error('Invoice was not passed as action argument');
    }

    const { invoice_id } = invoice;


    NavTabHelper.updateSingleNavTabDetails(invoice_id, CostsDetails => {
      return {
        loading: true,
      }
    })

    // DEPCRECATED_COMMENT: Forwarding Tab has a small response size that includes Only Invoice Object

    const invoiceLineData = await CostsService.findCostOverViewTabData(invoice.invoice_id)


    NavTabHelper.updateSingleNavTabDetails(invoice_id, CostsDetails => {
      return {
        invoice: invoiceLineData?.data?.invoice,
        loading: false,
      }
    })
  },

  async [types.CostsDetails.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const { name, value, item } = payload
    const { invoice } = item;
    const { invoice_id } = invoice;


    console.log("types.CostsDetails.UPDATE.SINGLE", name, value, item)
    NavTabHelper.updateSingleNavTabDetails(invoice_id, (CostsDetails) => {
      return {
        invoice: {
          ...CostsDetails.invoice,
          [name]: value,
        }
      }
    });

    if (name === 'currency_id') {
      await CostsService.update_currency(invoice_id, value);
    } else {
      await MHTTPCL.modifyJSON('invoice_id', invoice_id, name, value, 'invoices')
    }
    dispatch(types.FETCH_ONLY_COST_INVOICE, { invoice });
  },
  async [types.AccountingCostPayments.SET.ALL]({ commit, getters, dispatch }, {
    payments,
    invoice_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(invoice_id, (_, costsDetailsObj) => {
      return {
        ...costsDetailsObj,
        payments: payments
      };
    })
  },
  async [types.InvoiceTotalCostSplit.SET.ALL]({ commit, getters, dispatch }, {
    amount,
    invoice_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(invoice_id, (_, costsDetailsObj) => {
      return {
        ...costsDetailsObj,
        amount: amount
      };
    })
  },
  async [types.AccountingCostLines.SET.ALL]({ commit, getters, dispatch }, {
    invoicelines,
    invoice_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(invoice_id, (_, costsDetailsObj) => {
      return {
        ...costsDetailsObj,
        invoicelines: invoicelines
      };
    });
    dispatch(types.FETCH_ONLY_COST_INVOICE, { invoice: { invoice_id: invoice_id } });
  },
  async [types.AccountingCostRecopables.SET.ALL]({ commit, getters, dispatch }, {
    recoupables,
    invoice_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(invoice_id, (_, costsDetailsObj) => {
      return {
        ...costsDetailsObj,
        recoupables: recoupables
      };
    })
  },
  async [types.AccountingCostOverview.SET.ALL]({ commit, getters, dispatch }, {
    overview,
    invoice_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(invoice_id, (_, costsDetailsObj) => {
      return {
        ...costsDetailsObj,
        ...overview
      };
    })
  },
  async [types.AccountingCostSplits.SET.ALL]({ commit, getters, dispatch }, {
    cost_splits,
    invoice_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(invoice_id, (_, costsDetailsObj) => {
      return {
        ...costsDetailsObj,
        cost_splits: cost_splits
      };
    })
  },
  async [types.AccountingCostsInvoice.SET.ALL]({ commit, getters, dispatch }, {
    invoice,
    invoice_id
  }) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(invoice_id, (_, costsDetailsObj) => {
      return {
        ...costsDetailsObj,
        invoice: invoice
      };
    })
  },

  // Related Files
  async [types.SET_COSTS_FILES](
    { dispatch, getters },
    { files, externalId, externalTable }
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const invoice_id = externalId;
    NavTabHelper.setSingleNavTabDetails(
      invoice_id,
      (_, costsDetailsObj) => {
        return {
          ...costsDetailsObj,
          files
        };
      }
    );
  },
  async [types.AccountingCostPayments.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, item, invoice } = payload;

    const { invoice_id } = invoice;

    const key = 'payment_id';
    const kVal = item[key];
    const table = 'payments';

    if (name !== 'currency_id') {



      NavTabHelper.updateSingleNavTabDetails(invoice_id, costObj => {
        const payments = costObj.payments.map(pmnt => {
          if (pmnt[key] == kVal) {
            return {
              ...pmnt,
              [name]: value
            };
          } else {
            return pmnt;
          }
        });

        const currency_id = invoice?.invoice?.currency_id;

        const payment_total = sumPayments(payments);

        if (allPaymentsSameCurrency(payments, currency_id)) {
          return {
            payments,
            payment_total,
          }
        }
        return {
          payments,
          payment_total: 0,
        }
      })

      const updatePayment = await HttpClient.modify(
        key,
        kVal,
        name,
        value,
        table
      );
    }

    else {
      const newCurrencyExchangeRate = (NavTabHelper.getSingDet(invoice_id).currencies.find(c => c.currency_id == value) || {})['exchange_rate'];


      NavTabHelper.updateSingleNavTabDetails(invoice_id, invoiceObj => {
        const payments = invoiceObj.payments.map(pmnt => {
          if (pmnt[key] == kVal) {
            return {
              ...pmnt,
              [name]: value,
              exchangerate: newCurrencyExchangeRate
            };
          } else {
            return pmnt;
          }
        });

        const currency_id = invoice?.invoice?.currency_id;

        const payment_total = sumPayments(payments);

        if (allPaymentsSameCurrency(payments, currency_id)) {
          return {
            payments,
            payment_total,
          }
        }
        return {
          payments,
          payment_total: 0,
        }
      })

      const updatePaymentCurr = await HttpClient.post(MODIFICATION_URL, {
        modify_type: 'record',
        table,
        kVal,
        currency_id: value,
        exchangerate: newCurrencyExchangeRate
      });
    }

  },
}
function sumPayments(payments) {
  return sum(payments.map(p => p.amount));
}

function allPaymentsSameCurrency(payments, currency_id) {
  return currency_id && payments.every(payment => payment.currency_id == currency_id);
}
